import Vue from 'vue'

import ViewUI from 'view-design';
import './assets/common/iview-variable.less'
// import './assets/common1/iview-variable.less'
// import 'font-awesome/css/font-awesome.css'



import coreStore from '../src/store/store'

import coreChannel from '../src/store/channel'

/**加载扩展**/
import extend from './extend/index'


import initProfile from './initProfile'
import routeHandler from './handler/routeHandler'

Vue.use(ViewUI)

import fxView from './global-components/fxView'
Vue.use(fxView)

import VueScrollTo from "vue-scrollto";
Vue.use(VueScrollTo)


// import sysView from './sys-components'
// Vue.use(sysView)
import './sys-components'


import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

// const App = () => import(/* webpackChunkName: "core-app" */'./components/layouts/App');
import App from './components/layouts/App'

// 移动端UI
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);


import './assets/patch.css'


async function startVue(app) {


  app.router.instance.beforeEach((to, from, next) => {

    //增强keepAlive在菜单类的记忆功能
    if (from.name != to.name && from.meta.keepAlive == true) {
      let routeItem = app.routesDict[from.name];
      if (routeItem.MenuParams)
        routeItem.MenuParams = from.params;
      if (routeItem.MenuQuery)
        routeItem.MenuQuery = from.query;
    }

    if (app.store.state.core.user && Number(app.store.state.core.user.status) === 2 && to.name !== 'core-resetPwd') {
      return next({
        name: 'core-resetPwd'
      })
    } else if (app.store.state.core.user && Number(app.store.state.core.user.authstate) === 1 && to.name !== 'core-auth') {
      //授权过期页面跳转
      return next({
        name: 'core-auth'
      })
    }

    else if (app.store.state.core.user && Number(app.store.state.core.user.status) !== 2 && to.name === 'core-resetPwd') {
      return next({
        path: '/404'
      })
    }

    next()
  });
  app.router.instance.afterEach((to, from) => {

    if (!app.__loadroute) {
      let tabtitle = window.QueryDict && window.QueryDict["tabtitle"] || ""
      if (tabtitle == "__menuname") {
        let routename = app.router.instance.currentRoute.name
        setTimeout(() => {
          if (app.menusDict[routename]) {
            document.title = app.menusDict[routename].text
          } else if (app.routesDict[routename]) {
            document.title = app.routesDict[routename].text
          }
        })
      }
      app.__loadroute = true
    }
  })
  app.$vue = new Vue({
    el: app.el,
    router: app.router.instance,
    store: app.store,
    render: h => h(App)
    //template: "<router-view></router-view>"
  });
}


function createJS(src, type, assetTimestamp) {
  return new Promise((resolve, reject) => {
    var script = document.createElement('script');
    // if (!type) type = 'text/javascript';
    script.type = type
    script.onload = function () {
      resolve()
    };
    script.onerror = function (ex) {
      reject(ex)
    }
    script.src = `${src}?t=${assetTimestamp}`;
    document.getElementsByTagName('head')[0].appendChild(script);
  }).catch(ex => {
    throw new Error(`${src} create failed`);

  })
}



// if (!window.FX_BASE_URL)
//   window.FX_BASE_URL = location.pathname.substr(0, location.pathname.lastIndexOf("/"));


async function initFX_DYNAMIC() {
  let local_t = new Date();


  let res = await axios({
    method: "get",
    url: window.FX_BASE_URL + "/api/public/core/checkNet",
    headers: {
      "mainjs": "1"
    }
  });

  window.InitSecurityResponseHeaders_Instance = res.headers;
  //
  window.core_bstimediff = new Date(res.headers.date).getTime() - local_t.getTime();
  let assetTimestamp = res.headers.fxlastmodified || new Date().getTime();

  window.FX_LAST_MODIFIED = assetTimestamp
  let unfix = "?t=" + assetTimestamp;
  let pkgobj = require("../package.json")

  try {

    if (res.data && res.data.mainjs) {
      window.app_mainjs_exec = eval(res.data.mainjs)
    }
    await createJS("web/core/lib/core-startup.umd.js", 'text/javascript', assetTimestamp)
    await window.coreStartUp.exec(assetTimestamp, { pkgobj, headers: res.headers })
  } catch (ex) {
    console.error('core-startup exec error:', ex.message);
  }

  // try 
  //   await createJS("web/core/lib/startup.js", 'text/javascript', assetTimestamp)
  // } catch (ex) {

  // }

  // try {
  //   if (window.FX_DYNAMIC) await window.FX_DYNAMIC(assetTimestamp, unfix)
  // } catch (ex) {
  //   console.error('FX_DYNAMIC init error:', ex.message);
  // }
}


async function start(app) {

  //加载扩展
  extend.loadExtends(app)


  //加载状态
  app.addStore(coreStore.name, coreStore.module)

  app.addStore(coreChannel.name, coreChannel)



  // 初始化系统配置
  await initProfile(app)

  await app.store.dispatch("notify/initNotice")


  // 在路由初始化前载入各个项目的init hook

  for (const fn of app.__FX_INIT) {
    await fn(app);
  }
  app.routes = app.router.routes;


  ////选择合适的布局
  //app.layout.defaultLayout =await getLayout(app)

  // 初始化模块（路由）
  await routeHandler.initRoute(app)

  //加载路由,这里的addRoutes是VueRouter的原生方法
  app.router.instance.addRoutes(app.routes)


  //启动vue
  await startVue(app)
}

export default { start, initFX_DYNAMIC }
